import { Tabs as AntTabs, TabsProps } from "antd";
import styled from "styled-components";

export const Tabs: typeof AntTabs = styled(AntTabs)<TabsProps>``;
